import { IntegrationsConfigurationModel } from "./types";

export const mockIntgrationsSettings : IntegrationsConfigurationModel = {
  // 4Trans system
  fourTrans: {
    filePathDrivers: "C:/Integrations/4Trans/drivers.csv",
  },

  // SuperTacho system
  superTacho: {
    filePathDrivers: "D:/EasyTacho/exports/drivers_import.xml",
  },

  // TMS Nawigator system
  tmsNawigator: {
    exportServiceUrl: "https://api.tmsnawigator.pl/export/borders",
  },

  // Webfleet system
  webfleet: {
    accountName: "TransportCompanyLtd",
    login: "admin.webfleet",
    password: "P@ssw0rd123",
    registrationPrefix: "PL-TR-",
  },

  // IMI system
  imi: {
    login: "imi_user",
    password: "imi_secret",
    company: "Speedy Logistics Sp. z o.o.",
    apiKey: "ZXC-ASD-QWE",
    operatorId: "qwertyuiop",
  },

  zus: {
    login: "zus_username",
    password: "zus_password",
    zipPassword: "zus_zip_password",
    nip: "123-456-789",
    nips: ["123-456-789"],
  },

  // NaviFleet system
  naviFleet: {
    apiKey: "NF-1234567890-ABCDEF",
  },

  // TachoBank2 system
  tachoBank2: {
    ftp: "ftp.tachobank2.pl",
    login: "tacho_user",
    port: 21,
    certFilePath: "C:/TachoBank2/certs/company_cert.csv",
    showNewFilesMessage: true,
    autoImportNewFiles: false,
    skipNewDrivers: true,
  },
}
